// Copyright © 2021 Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'
import { BootstrapButton, BootstrapIcon, BootstrapImage } from '../../../dsl/front'

import { ResolvedEditorialOfficeAuthor } from '../EditorialOffice.contracts'

@Component<AuthorInfoSidebar>({
  name: 'AuthorInfoSidebar',
  components: {
    BootstrapImage,
    BootstrapIcon,
    BootstrapButton
  },

  template: `
    <div>
    <!-- Sidebar Overlay -->
    <div class="editorial-office-module__sidebar__overlay" @click="close"></div>
    <div class="editorial-office-module__sidebar">

      <div class="editorial-office-module__sidebar__close">
        <BootstrapButton @click="close">
          <BootstrapIcon size="large" name="close" />
        </BootstrapButton>
      </div>

      <div v-if="author" class="editorial-office-module__sidebar__content">
        <!-- Image -->
        <div class="editorial-office-module__sidebar__content__image">
          <BootstrapImage v-bind="author.avatar"/>
        </div>
        <!-- Author full name -->
        <div class="editorial-office-module__sidebar__content__full_name">
          <p>{{author.firstName}} {{author.lastName}}</p>
        </div>
        <!-- Author position -->
        <div v-if="author.position" class="editorial-office-module__sidebar__content__position">
          <span>{{author.position}}</span>
        </div>
        <!-- Author description -->
        <div v-if="author.description" class="editorial-office-module__sidebar__content__description">
          <p>{{author.description}}</p>
        </div>
      </div>

    </div>
    </div>`
})
export class AuthorInfoSidebar extends Vue {
  @Prop({ type: Object, required: true })
  public readonly author!: ResolvedEditorialOfficeAuthor

  public close (): void {
    this.$emit('sidebar-close')
  }

  public open (value: boolean): void {
    this.$emit('sidebar-open')
  }
}
